(function(){
const wrap=document.querySelector('[data-pcut]');if(!wrap)return;
const D=window.PCUT_DATA||{};
const variantData=D.variants||[];
const ctaLabel=D.ctaLabel||'Add to bag';
const width=Number(D.width)||5.25;
const minLen=Number(D.minLen)||5;
const maxLen=Number(D.maxLen)||90;
const startLen=Number(D.startLen)||20;
const hasColor=D.hasColor!==false;
const fullLen=(D.fullLen==null)?0:Number(D.fullLen);
const hasFull=fullLen>0;
const hasFullStop=hasFull&&fullLen>maxLen+0.001;
const sliderMax=hasFullStop?maxLen+1:maxLen;
const vid=wrap.querySelector('[data-pcut-vid]');
const qtyIn=wrap.querySelector('[data-pcut-qty]');
const qtyDec=wrap.querySelector('[data-pcut-qty-dec]');
const qtyInc=wrap.querySelector('[data-pcut-qty-inc]');
const lenIn=wrap.querySelector('[data-pcut-len]');
const dimsW=wrap.querySelector('[data-pcut-dims-w]');
const dimsL=wrap.querySelector('[data-pcut-dims-l]');
const sqftOut=wrap.querySelector('[data-pcut-sqft]');
const totalOut=wrap.querySelector('[data-pcut-total]');
const bigsize=wrap.querySelector('[data-pcut-bigsize]');
const cardDims=wrap.querySelector('[data-pcut-card-dims]');
const cardTitle=wrap.querySelector('[data-pcut-cardtitle]');
const headlinePriceOut=wrap.querySelector('[data-pcut-headline-price]');
const ratesOut=wrap.querySelector('[data-pcut-rates]');
const savingsBadge=wrap.querySelector('[data-pcut-savings-badge]');
const savingsVal=wrap.querySelector('[data-pcut-savings-val]');
const compareOut=wrap.querySelector('[data-pcut-compare]');
const offBadge=wrap.querySelector('[data-pcut-off]');
const ctaTotal=wrap.querySelector('[data-pcut-cta-total]');
const submitBtn=wrap.querySelector('[data-pcut-submit]');
const mainImg=wrap.querySelector('.pgallery__main img');
const colorLabel=wrap.querySelector('[data-pcut-color-label]');
const shipsOut=wrap.querySelector('[data-pcut-ships]');
const stockLabel=wrap.querySelector('[data-pcut-stock-label]');
const dealBanner=wrap.querySelector('[data-pcut-deal-banner]');
const dealTitle=wrap.querySelector('[data-pcut-deal-title]');
const dealSub=wrap.querySelector('[data-pcut-deal-sub]');
const dealCta=wrap.querySelector('[data-pcut-deal-cta]');
const sticky=document.querySelector('[data-pcut-sticky]');
const stickyTotal=document.querySelector('[data-pcut-sticky-total]');
const stickyAdd=document.querySelector('[data-pcut-sticky-add]');
const poBanner=wrap.querySelector('[data-pcut-preorder]');
const poBannerMsg=wrap.querySelector('[data-pcut-preorder-msg]');
const poInput=wrap.querySelector('[data-pcut-preorder-input]');

/* Discount-code pricing on cut rolls (2026-08-08; wired to window.DFI_SALE 2026-08-17).
   The sale is a discount CODE, so variant prices are the full everyday prices and there is no
   compare_at to drive a strikethrough. This shows the code price as the headline with the full
   price struck beside it, plus an unmissable "with code" pill, and self-disables the moment the
   sale deadline passes so the page can never advertise a finished offer.
   Transactional numbers (Your roll, Add to bag, cart) deliberately stay at the FULL price, because
   that is what is charged until the code is entered at checkout.
   ⚠ Code / percent / deadline come from window.DFI_SALE, published by
   sections/code-price-display.liquid in the header group. Change the sale in THAT section's theme
   settings — do not hardcode values here. The fallbacks below only matter if that section is
   removed from the header group. */
const SALE=window.DFI_SALE||{};
const SALE_CODE=SALE.code||'SUMMER';
const SALE_PCT=Number(SALE.pct)||5;
const SALE_MULT=(100-SALE_PCT)/100;
const SALE_END_MS=Number(SALE.endMs)||Date.parse('2026-08-23T23:59:59-07:00');
function saleLive(){
  if(SALE.live===false)return false;
  return isFinite(SALE_END_MS)&&Date.now()<SALE_END_MS;
}
let compareEl=null,codePillEl=null;
function ensureSaleEls(){
  const row=wrap.querySelector('.pbuy__price-row');
  if(!row)return;
  if(!compareEl){
    compareEl=document.createElement('span');
    compareEl.className='pbuy__compare-at';
    compareEl.hidden=true;
    const unit=row.querySelector('.pbuy__price-unit');
    if(unit&&unit.insertAdjacentElement){unit.insertAdjacentElement('afterend',compareEl);}else{row.appendChild(compareEl);}
  }
  if(!codePillEl){
    codePillEl=document.createElement('span');
    codePillEl.className='pbuy__sale-badge';
    codePillEl.hidden=true;
    if(compareEl&&compareEl.insertAdjacentElement){compareEl.insertAdjacentElement('afterend',codePillEl);}else{row.appendChild(codePillEl);}
  }
}
(function injectSaleCss(){
  if(document.getElementById('dfi-sale-css'))return;
  const s=document.createElement('style');s.id='dfi-sale-css';
  s.textContent='.pbuy__compare-at{margin-left:.5rem;text-decoration:line-through;opacity:.6;font-weight:500}'+
    '.pbuy__code-note{margin:.35rem 0 0;font-size:.85rem;font-weight:600;color:var(--color-accent-pink,#ec2a7e)}';
  document.head.appendChild(s);
})();

function money(c){return '$'+(c/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',');}
function moneyRound(c){return '$'+Math.round(c/100).toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');}

function lenOf(s){if(!s)return null;const m=String(s).match(/(\d+(?:\.\d+)?)\s*'/g);if(!m)return null;return parseFloat(m[m.length-1]);}
function findVariant(color,len){
  for(let i=0;i<variantData.length;i++){
    const v=variantData[i];
    if(hasColor&&v.option1!==color)continue;
    const l=lenOf(hasColor?v.option2:v.option1);
    if(l!=null&&Math.abs(l-len)<0.01)return v;
  }
  return null;
}
function ppfFor(color){const v=findVariant(color,minLen);return v?(v.price/100)/minLen:0;}
function selectedColor(){
  const p=wrap.querySelector('[data-pcut-color-val][aria-pressed="true"]');
  if(p)return p.dataset.pcutColorVal;
  return (variantData[0]&&variantData[0].option1)||'Black';
}
function selectedSwatch(){return wrap.querySelector('[data-pcut-color-val][aria-pressed="true"]');}
function clampLen(n){n=Math.round(Number(n)||minLen);if(n<minLen)n=minLen;if(n>sliderMax)n=sliderMax;return n;}
function clampQty(n){n=Math.round(Number(n)||1);if(n<1)n=1;if(n>99)n=99;return n;}

let ft=clampLen(lenIn?lenIn.value:startLen);
let qty=clampQty(qtyIn?qtyIn.value:1);

function recompute(){
  const color=selectedColor();
  let poMsg='',poProp='';
  if(hasColor){const sw=selectedSwatch();if(sw){poMsg=sw.getAttribute('data-pcut-po-msg')||'';poProp=sw.getAttribute('data-pcut-po-prop')||'';}}
  else{poMsg=D.poMsg||'';poProp=D.poProp||'';}
  const isPre=poMsg!=='';
  const label=isPre?'Pre-order':ctaLabel;
  ft=clampLen(lenIn?lenIn.value:ft);
  qty=clampQty(qtyIn?qtyIn.value:qty);

  const len=(hasFullStop&&ft>=sliderMax)?fullLen:ft;
  const isFull=hasFull&&Math.abs(len-fullLen)<0.01;
  const lenLabel=(isFull&&hasFullStop)?String(fullLen):String(Math.round(len));

  const v=findVariant(color,len);
  if(!v){
    if(poBanner){poBanner.hidden=!isPre;if(isPre&&poBannerMsg)poBannerMsg.textContent=poMsg;}
    if(poInput)poInput.disabled=true;
    if(submitBtn)submitBtn.disabled=true;
    return;
  }

  const unitPriceCents=v.price;
  const lineTotalCents=unitPriceCents*qty;

  const ppf=ppfFor(color);
  const expectedCents=Math.round(ppf*100*len);
  const savingsCents=Math.max(0,expectedCents-unitPriceCents);

  if(dimsW)dimsW.textContent=String(width);
  if(dimsL)dimsL.textContent=lenLabel;
  if(cardDims)cardDims.textContent=width+'′ × '+lenLabel+'′';
  if(cardTitle)cardTitle.textContent=isFull?'Full roll':'Custom cut';
  if(bigsize)bigsize.textContent=lenLabel;
  const sqft=Math.round(width*len*10)/10;
  if(sqftOut)sqftOut.textContent=String(sqft);

  if(lenIn){
    const pct=((ft-minLen)/(sliderMax-minLen))*100;
    lenIn.style.setProperty('--pct',pct+'%');
  }

  if(totalOut)totalOut.textContent=money(lineTotalCents);
  if(headlinePriceOut)headlinePriceOut.textContent=money(unitPriceCents);
  if(ratesOut){const plf=(unitPriceCents/100)/len;const psf=(unitPriceCents/100)/(len*width);ratesOut.textContent='$'+plf.toFixed(2)+' / linear ft · $'+psf.toFixed(2)+' / sq ft';}
  if(ctaTotal)ctaTotal.textContent=money(lineTotalCents);
  if(stickyTotal)stickyTotal.textContent=money(lineTotalCents);

  if(savingsBadge){
    if(savingsCents>0){
      savingsBadge.hidden=false;
      if(savingsVal)savingsVal.textContent=moneyRound(savingsCents);
    }else{
      savingsBadge.hidden=true;
    }
  }

  /* Compare-at sale display (2026-08-24 Huge Sale): the variant's compare_at_price drives the
     strike + % OFF badge. Purely data-driven — remove the compare-at prices and this hides itself.
     While a compare-at strike is showing, the volume "SAVE $" pill stays hidden (the full-roll
     deal banner below still communicates the per-foot saving). */
  const capCents=(v.cap==null)?0:Number(v.cap);
  const onSale=capCents>unitPriceCents;
  if(compareOut){compareOut.hidden=!onSale;if(onSale)compareOut.textContent=money(capCents);}
  if(offBadge){offBadge.hidden=!onSale;if(onSale)offBadge.textContent=Math.round((capCents-unitPriceCents)*100/capCents)+'% OFF';}
  if(onSale&&savingsBadge)savingsBadge.hidden=true;

  if(dealBanner){
    const fullRoll=hasFull?findVariant(color,fullLen):null;
    const expectedFull=Math.round(ppf*100*fullLen);
    const fullRollSavings=fullRoll?Math.max(0,expectedFull-fullRoll.price):0;
    if(fullRollSavings<=0){
      dealBanner.style.display='none';
    }else{
      dealBanner.style.display='';
      if(isFull){
        dealBanner.setAttribute('data-active','true');
        if(dealTitle)dealTitle.textContent='Full roll active · saving '+moneyRound(fullRollSavings);
        if(dealSub)dealSub.textContent='You picked the whole '+width+'′ × '+fullLen+'′ roll at the best per-foot value.';
        if(dealCta)dealCta.textContent='✓ Applied';
      }else{
        dealBanner.setAttribute('data-active','false');
        if(dealTitle)dealTitle.textContent='Save '+moneyRound(fullRollSavings)+' with a full roll';
        if(dealSub)dealSub.textContent='The whole '+width+'′ × '+fullLen+'′ roll is priced below per-foot, your best value.';
        if(dealCta)dealCta.textContent='Get full roll →';
      }
    }
  }

  // Stock + shipping perks toggle based on full-roll vs custom cut
  if(isFull){
    if(stockLabel)stockLabel.textContent='In stock';
    if(shipsOut)shipsOut.textContent='In stock, ships in 1-2 business days';
  }else{
    if(stockLabel)stockLabel.textContent='Made to order';
    if(shipsOut)shipsOut.textContent=(shipsOut.getAttribute('data-ship-text')||'Made to order, ships in 3-5 business days');
  }
  if(isPre){
    if(stockLabel)stockLabel.textContent='Pre-order';
    if(shipsOut)shipsOut.textContent='Pre-order, ships when stock arrives';
  }
  if(poBanner){poBanner.hidden=!isPre;if(isPre&&poBannerMsg)poBannerMsg.textContent=poMsg;}
  if(poInput){poInput.disabled=!isPre;if(isPre)poInput.value=poProp;}
  if(stickyAdd)stickyAdd.textContent=label;

  if(vid)vid.value=v.id;
  if(submitBtn){
    const enabled=v.available||isPre;
    submitBtn.disabled=!enabled;
    if(enabled){
      submitBtn.innerHTML=label+' <span class="price-tag" data-pcut-cta-total>'+money(lineTotalCents)+'</span>';
    }else{
      submitBtn.textContent='Sold out';
    }
  }

  if(v.featured_image&&v.featured_image.src&&mainImg){
    if(mainImg.src!==v.featured_image.src){
      mainImg.srcset='';mainImg.sizes='';mainImg.src=v.featured_image.src+(v.featured_image.src.indexOf('?')>-1?'&':'?')+'width=1600';
    }
  }

  /* discount-code price — runs last so it wins over the volume-savings pill above */
  if(saleLive()){
    ensureSaleEls();
    const codeCents=Math.round(unitPriceCents*SALE_MULT);
    if(compareEl&&codePillEl&&codeCents<unitPriceCents){
      if(headlinePriceOut)headlinePriceOut.textContent=money(codeCents);
      compareEl.hidden=false;compareEl.textContent=money(unitPriceCents);
      codePillEl.hidden=false;codePillEl.textContent='WITH CODE '+SALE_CODE;
      if(savingsBadge)savingsBadge.hidden=true;
      let note=wrap.querySelector('.pbuy__code-note');
      if(!note){
        const row=wrap.querySelector('.pbuy__price-row');
        if(row){note=document.createElement('p');note.className='pbuy__code-note';row.insertAdjacentElement('afterend',note);}
      }
      if(note)note.textContent='Enter code '+SALE_CODE+' at checkout for '+SALE_PCT+'% off · '+money(unitPriceCents*qty)+' in your bag today';
    }
  }
}

wrap.querySelectorAll('[data-pcut-color-val]').forEach(b=>{
  b.addEventListener('click',()=>{
    wrap.querySelectorAll('[data-pcut-color-val]').forEach(x=>x.setAttribute('aria-pressed','false'));
    b.setAttribute('aria-pressed','true');
    if(colorLabel)colorLabel.textContent=b.dataset.pcutColorVal;
    recompute();
  });
});

if(lenIn){
  lenIn.max=String(sliderMax);
  lenIn.addEventListener('input',()=>{ft=clampLen(lenIn.value);recompute();});
  lenIn.addEventListener('change',()=>{ft=clampLen(lenIn.value);recompute();});
}

if(qtyIn){
  qtyIn.addEventListener('input',()=>{qty=clampQty(qtyIn.value);recompute();});
  qtyIn.addEventListener('change',()=>{qty=clampQty(qtyIn.value);if(String(qtyIn.value)!==String(qty))qtyIn.value=qty;recompute();});
}
if(qtyDec)qtyDec.addEventListener('click',()=>{qty=clampQty(qty-1);if(qtyIn)qtyIn.value=qty;recompute();});
if(qtyInc)qtyInc.addEventListener('click',()=>{qty=clampQty(qty+1);if(qtyIn)qtyIn.value=qty;recompute();});

if(dealBanner){
  dealBanner.addEventListener('click',e=>{
    e.preventDefault();
    if(ft===sliderMax)return;
    ft=sliderMax;
    if(lenIn)lenIn.value=sliderMax;
    recompute();
    if(dealBanner.scrollIntoView)dealBanner.scrollIntoView({behavior:'smooth',block:'nearest'});
  });
}

wrap.querySelectorAll('[data-pgallery-thumb]').forEach(t=>{
  t.addEventListener('click',()=>{
    wrap.querySelectorAll('[data-pgallery-thumb]').forEach(x=>x.setAttribute('aria-pressed','false'));
    t.setAttribute('aria-pressed','true');
    if(mainImg){mainImg.srcset='';mainImg.sizes='';mainImg.src=t.dataset.imageUrl;}
    initZoom();
  });
});

const mb=wrap.querySelector('.pgallery__main');
const lens=wrap.querySelector('[data-zoom-lens]');
const panel=wrap.querySelector('[data-zoom-panel]');
function initZoom(){if(!mb||!mainImg||!lens||!panel)return;const u=(mainImg.currentSrc||mainImg.src||'').split('?')[0];if(u)panel.style.backgroundImage='url('+u+')';}
if(mb&&lens&&panel&&mainImg){
  initZoom();mainImg.addEventListener('load',initZoom);
  const Z=2.5;
  mb.addEventListener('mousemove',e=>{
    if(window.innerWidth<1100)return;
    const r=mb.getBoundingClientRect();
    const x=e.clientX-r.left,y=e.clientY-r.top;
    if(x<0||y<0||x>r.width||y>r.height){mb.setAttribute('data-zoom-on','false');return;}
    mb.setAttribute('data-zoom-on','true');
    const lw=lens.offsetWidth,lh=lens.offsetHeight;
    lens.style.left=Math.max(0,Math.min(r.width-lw,x-lw/2))+'px';
    lens.style.top=Math.max(0,Math.min(r.height-lh,y-lh/2))+'px';
    panel.style.backgroundSize=(Z*100)+'% auto';
    panel.style.backgroundPosition=(x/r.width*100)+'% '+(y/r.height*100)+'%';
  });
  mb.addEventListener('mouseleave',()=>mb.setAttribute('data-zoom-on','false'));
}

/* image lightbox + its hiRes helper fully removed (2026-06-18): it was a fixed full-screen z-9999 overlay that opened invisibly (opacity:0) on tap and silently blocked scroll/taps on mobile. Thumbnail swap + desktop hover-zoom are separate and unaffected. */

/* Zendesk launcher lift (2026-08-10): the sticky Add-to-bag bar (~70px) and the chat launcher
   (fixed, bottom 16px) both live at the bottom edge on mobile — the launcher lands ON the Add
   button. Zendesk's widgetOnLoad keyframe animation (fill:forwards) owns transform AND bottom,
   and Blink lets a filled animation beat author !important, so stylesheet overrides of those
   properties silently lose. margin-bottom is not in the keyframes and works; set inline-important
   here, in the same observer that toggles the bar, so the two can never disagree. */
function liftChat(on){
  if(window.innerWidth>900)on=false;
  ['Button to launch messaging window','Message from company','Close message'].forEach(function(t){
    var f=document.querySelector('iframe[title="'+t+'"]');
    if(!f)return;
    if(on){ f.style.setProperty('margin-bottom','78px','important'); }
    else { f.style.removeProperty('margin-bottom'); }
  });
}

if(sticky&&submitBtn){const io=new IntersectionObserver(([e])=>{sticky.setAttribute('data-visible',e.isIntersecting?'false':'true');document.body.classList.toggle('pbuy-sticky-on',!e.isIntersecting);liftChat(!e.isIntersecting);},{rootMargin:'0px 0px -40px 0px'});io.observe(submitBtn);if(stickyAdd)stickyAdd.addEventListener('click',()=>{submitBtn.click();});}

recompute();
})();window.addEventListener('load',function(){setTimeout(function(){document.querySelectorAll('[data-pgallery-thumb]').forEach(function(t){var im=new Image();im.src=t.dataset.imageUrl;});},600);});
